import { render, staticRenderFns } from "./EmailPhoneField.vue?vue&type=template&id=0ea10745&scoped=true"
import script from "./EmailPhoneField.vue?vue&type=script&lang=js"
export * from "./EmailPhoneField.vue?vue&type=script&lang=js"
import style0 from "./EmailPhoneField.vue?vue&type=style&index=0&id=0ea10745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea10745",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
